import { render } from "./HeaderCelebrimbor.vue?vue&type=template&id=43efd0e7&scoped=true"
import script from "./HeaderCelebrimbor.vue?vue&type=script&lang=js"
export * from "./HeaderCelebrimbor.vue?vue&type=script&lang=js"

import "./HeaderCelebrimbor.vue?vue&type=style&index=0&id=43efd0e7&scoped=true&lang=css"

import exportComponent from "../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-43efd0e7"]])

export default __exports__